import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cloneElement } from "react";
import styled from "styled-components";
import { useTranslation } from "../../../i18n/useTranslation";
import { Footer, Form, SmallTitle } from "../Styles";
import { ErrorMessages } from "./ErrorMessages";
export const PaymentAlipay = ({ recaptchaV2, disclaimer, actions, useAlipay, }) => {
    const { t } = useTranslation();
    const info = useAlipay();
    return (_jsxs(_Fragment, { children: [_jsx(SmallTitle, { children: t("checkout.alipay.title") }), _jsxs(Form, { onSubmit: info?.handleSubmit(info?.onSubmitAlipay), children: [_jsx(Description, { children: t("checkout.alipay.description") }), info?.formState?.errors?.root?.stripe && (_jsx(ErrorMessages, { type: "alipay", message: info?.formState?.errors?.root?.stripe?.message })), _jsxs(Footer, { children: [disclaimer, recaptchaV2 && info?.isEnabledRecaptchaV2 && (_jsx(CaptchaWrapper, { children: recaptchaV2 })), cloneElement(actions, {
                                isLoading: info?.isLoading,
                                isSubmitting: info?.isSubmitting,
                            })] })] })] }));
};
const Description = styled.p `
  font-weight: 400;
  font-size: 18px;
  line-height: 1.44;
  color: ${(p) => p.theme.systemColors.grey600};
  margin: ${(p) => `${p.theme.spacing.sp16} 0`};
`;
const CaptchaWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: ${(p) => p.theme.spacing.sp16};
`;
